import axios from '../axios';
// import router from '@/router/index';

export default {
  namespaced: true,
  state: () => ({
    km_groups: [],
  }),
  actions: {
    async list(_, payload) {
      try {
        const response = await axios.get(`/km/v2?term=${payload.term}&group=${payload.type}&page=${payload.page}`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get(_, id) {
      try {
        const { data } = await axios.get(`/forms/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async edit(_, id) {
      try {
        const { data } = await axios.get(`/km/${id}/edit`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get_types({ commit }) {
      try {
        const response = await axios.get(`/forms/forms_type`);
        commit('SET_NEWS_TYPES', response.data);
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async store(_, form_data) {
      try {
        const { data } = await axios.post(`/km`, form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async update(_, form_data) {
      try {
        const { data } = await axios.post(`/km/${form_data.get('id')}`, form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async delete(_, id) {
      try {
        const { data } = await axios.delete(`/km/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    }
  }
}